import { LayoutServicePageState, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { useEffect, useState } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import useOneTrust from '@greystar/ui/src/hooks/useOneTrust';

const DataDogInit = (): JSX.Element => {
  const {
    sitecoreContext: { pageState, route, variantId, site },
  } = useSitecoreContext();
  const { consentGroups } = useOneTrust();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    const trackingConsent = consentGroups['performance'] ? 'granted' : 'not-granted';
    datadogRum.setTrackingConsent(trackingConsent);
  }, [consentGroups]);

  /**
   * Determines if data dog monitoring should be turned off.
   * By default it is disabled in development mode
   */
  const disabled = () => {
    return process.env.NODE_ENV === 'development' || !consentGroups['performance'];
  };

  useEffect(() => {
    // Do not monitor in editing or preview mode or if missing route data
    if (pageState !== LayoutServicePageState.Normal || !route?.itemId) {
      return;
    }
    // Do not monitor if disabled
    if (disabled() || initialized) {
      return;
    }

    datadogRum.init({
      applicationId: process.env.NEXT_PUBLIC_DataDogApplicationId ?? '',
      clientToken: process.env.NEXT_PUBLIC_DataDogClientToken ?? '',
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: 'us5.datadoghq.com',
      service: process.env.NEXT_PUBLIC_DataDogService ?? '',
      env: process.env.NEXT_PUBLIC_DataDogEnv ?? '',
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: process.env.NEXT_PUBLIC_DataDogSessionReplaySampleRate
        ? Number(process.env.NEXT_PUBLIC_DataDogSessionReplaySampleRate)
        : 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });

    setInitialized(true);
  }, [pageState, route, variantId, site, consentGroups]);

  return <></>;
};

export default DataDogInit;
